"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var blockFormat_1 = require("../utils/blockFormat");
var roosterjs_editor_dom_1 = require("roosterjs-editor-dom");
/**
 * Toggle List Type at selection
 * If ListType Provided is Ordered:
 *      If selection contains numbering in deep level, toggle numbering will decrease the numbering level by one
 *      If selection contains bullet list, toggle numbering will convert the bullet list into number list
 *      If selection contains both bullet/numbering and normal text, the behavior is decided by corresponding
 *       realization of browser execCommand API
 * If ListType Provided is Unordered:
 *      If selection contains bullet in deep level, toggle bullet will decrease the bullet level by one
 *      If selection contains number list, toggle bullet will convert the number list into bullet list
 *      If selection contains both bullet/numbering and normal text, the behavior is decided by corresponding
 *      browser execCommand API
 * @param editor The editor instance
 * @param listType The list type to toggle
 * @param startNumber (Optional) Start number of the list
 * @param includeSiblingLists Sets wether the operation should include Sibling Lists, by default true
 */
function toggleListType(editor, listType, startNumber, includeSiblingLists) {
    if (includeSiblingLists === void 0) { includeSiblingLists = true; }
    blockFormat_1.default(editor, function (region, start, end, chains) {
        var _a;
        var chain = startNumber > 0 && chains.filter(function (chain) { return chain.canAppendAtCursor(startNumber); })[0];
        var vList = chain && start.equalTo(end)
            ? chain.createVListAtBlock((_a = roosterjs_editor_dom_1.getBlockElementAtNode(region.rootNode, start.node)) === null || _a === void 0 ? void 0 : _a.collapseToSingleElement(), startNumber)
            : roosterjs_editor_dom_1.createVListFromRegion(region, includeSiblingLists);
        if (vList) {
            vList.changeListType(start, end, listType);
            vList.writeBack();
        }
    });
}
exports.default = toggleListType;
//# sourceMappingURL=toggleListType.js.map